import { Page } from '../components';
import { APTestingForm } from '../forms';

export const APTesting = () => <Page render={() => <APTestingForm />} />;
